import { useState } from "react";
import Skeleton from "react-loading-skeleton";
import ModalPageFooter from "../../../global-layout/modal-page-footer";
import {
  SelectInputWithoutForm,
} from "../../../form/select-input";
import { processServices } from "../../../../services/InspectionOneServices";
import ToastifyMessage from "../../../../lib/toastify";
import { ToastError, ToastSuccess, ToastWarning } from "../../../UI/toast";


function OpenPdfModalForm({setIsPdfModalOpen,handleRefresh, processUpdated, siteConfigDetails, pdfOptions, isPdfLoading, setPdfLoading }: any) {
  const [errors, setErrors] = useState({
    reportDownloadOption: "",
  });
  const [isLoading, setIsLoading] = useState(false);
  const [selectedDispatchNumber, setSelectedDispatchNumber] = useState("");

  const handleFormSubmit = async () => {
    try {
      setPdfLoading(true);
      setIsLoading(true);
      if(selectedDispatchNumber == ""){
        setErrors((prevErrors) => ({
          ...prevErrors,
          reportDownloadOption: "Select any option",
        }));
        setPdfLoading(false);
        setIsLoading(false);
      }
      else{
        const parsedDetails = JSON.parse(siteConfigDetails.reportDetails);
        const requestJson = {
          filterValue: selectedDispatchNumber,
          masterAccessId: parsedDetails?.masterAccessId 
          ? parsedDetails?.masterAccessId 
          : ""
        };
        const response: any = await processServices.PdfGenerate(
          requestJson
        );
        if (response.success) {
          setIsLoading(false);
          const link = document.createElement("a");
          link.href = response.data.responseResult.bloburl;
          link.setAttribute("download", "exported_file_name.extension");
          document.body.appendChild(link);
          link.click();
          link.remove();
          setIsPdfModalOpen(false)
          setPdfLoading(false);
        }
        else{
          handleError("No Data", "No data available for this dispatch number");
        }
        setIsLoading(false);
        setPdfLoading(false);
        }
    } catch (error) {setIsLoading(false);
      setPdfLoading(false);}
  };
  const handleFormCancel = () => {
    setIsPdfModalOpen(false)
  };

  const handleInputChange = (value: any) => {
    setSelectedDispatchNumber(value);
  };

  const { ToastifyHandle } = ToastifyMessage();

  const handleSuccess = (titleName: any, message: any) => {
    ToastifyHandle(
      <ToastSuccess title={titleName} description={message} />,
      "success"
    );
  };
  const handleError = (titleName: any, message: any) => {
    ToastifyHandle(
      <ToastError title={titleName} description={message} />,
      "error"
    );
  };
  const handleWarning = (titleName: any, message: any) => {
    ToastifyHandle(
      <ToastWarning title={titleName} description={message} />,
      "warning"
    );
  };

  return (
    <div className="w-full h-full flex flex-col">
      <div className="w-full flex-auto basis-0 pr-2 overflow-y-auto scrollbar-large">
        <div className="w-[100%] h-auto">
          <div className="w-full h-auto flex justify-between items-start pt-4">
            <div className="w-[48%]">
              <div className="mb-[3.8rem]">
                {isLoading ? (
                  <Skeleton width="100%" height={47} borderRadius={3} />
                ) : (
                  <SelectInputWithoutForm
                    labelName="Dispatch Number"
                    id="reportDownloadOption"
                    isRequired={true}
                    error={errors.reportDownloadOption}
                    options={pdfOptions.map((data: any) => ({
                      label: data.value,
                      id: data.id,
                    }))}
                    getOptionLabel={(option: any) => option.label}
                    getOptionValue={(option: any) => option.id}
                    getSelection={(option: any) =>
                      handleInputChange(option.label)
                    }
                  />
                )}
              </div>
            </div>
          </div>
          <div className="border border-1"></div>
        </div>
      </div>
      <ModalPageFooter
          footerType="onlyDownloadButton"
          handleCancel={handleFormCancel}
          handleSubmit={handleFormSubmit}
          isLoading={isLoading}
          buttonText={"Download"}
        />
    </div>
  );
}

export default OpenPdfModalForm;
